module.exports = __webpack_public_path__ + "img/MAC.1c8c50c5.svg";